import Avatar from '@material-ui/core/Avatar';
import Chip from '@material-ui/core/Chip';
import IconButton from '@material-ui/core/IconButton';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import HelpIcon from '@material-ui/icons/Help';
import MoodIcon from '@material-ui/icons/Mood';
import MoodBadIcon from '@material-ui/icons/MoodBad';
import NewReleasesIcon from '@material-ui/icons/NewReleases';
import PersonIcon from '@material-ui/icons/Person';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import PropTypes from 'prop-types';
import React from 'react';
import { ENTITLEMENTS } from '../../application-core/constants';
import IriDisplay from '../../vocabulary/taxonomies/IriDisplay';
import LangConfirmationField from '../LangConfirmationField';
import { globalStyles as styles } from '../style/gstheme';
import { STATUS_ACCEPTED, STATUS_DRAFT, STATUS_REJECTED } from '../utils/constants';
import withGS from '../withGShoc';
import AssignUserDialog from './AssignUserDialog';

const DRAFT = STATUS_DRAFT;
const APPROVED = STATUS_ACCEPTED;
const REJECTED = STATUS_REJECTED;
const BAR_RADIUS = 20;
const BAR_WIDTH = 120;

class ResourceDisplay extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      showAssignUserDialog: false
    };
  }

  setToStatus = (status) => {
    // Remove any existing rejection note
    let existingLang = undefined;
    if (this.props.data.rejectedNote !== undefined && Object.keys(this.props.data.rejectedNote).length > 0) {
      existingLang = Object.keys(this.props.data.rejectedNote)[0];
    }
    if (existingLang !== undefined) {
      const text = this.props.data.rejectedNote[existingLang];
      this.props.onDelete('rejectedNote', text, existingLang);
    }
    if (this.props.data.status !== undefined) {
      // Something has gone wrong!
      if (this.props.data.status.length > 1) return;
      // Just make sure nobody else had set it
      if (this.props.data.status !== status) {
        this.props.onUpdate('status', status, null, 0);
      }
    }
    else {
      this.props.onAdd('status', status);
    }
    this.setState({
      statusChangesHistory: [],
      showStatusTimeline: false,
      showHistorySinceStatusChange: false
    });
  };

  setToApproved = () => {
    this.props.data.status !== undefined ?
      this.props.onUpdate('status', APPROVED, null, 0)
      :
      this.props.onAdd('status', APPROVED);
  };

  showAssignUser = () => this.setState({ showAssignUserDialog: true });

  cancelAssignUser = () => this.setState({ showAssignUserDialog: false });

  assignUser = (user, text, lang) => {
    if (user === "All") user = undefined;
    this.setState({ showAssignUserDialog: false, user });
    if (!(this.props.data.assignedUser === undefined && user === undefined) && this.props.data.assignedUser !== user) {
      this.props.data.assignedUser !== undefined ?
        user === undefined ?
          this.props.onDelete('assignedUser', this.props.data.assignedUser)
          :
          this.props.onUpdate('assignedUser', user)
        :
        this.props.onAdd('assignedUser', user);
    }
    let valueExistsAlready = false;
    const langExistsAlready = this.props.data.assignedNote && this.props.data.assignedNote[lang];
    if (langExistsAlready) {
      const langValues = Array.isArray(this.props.data.assignedNote[lang]) ?
        this.props.data.assignedNote[lang]
        :
        [this.props.data.assignedNote[lang]];
      valueExistsAlready = langValues.includes(text);
    }
    if (!valueExistsAlready && text !== "") {
      this.props.onAdd('assignedNote', text, lang);
    }
    this.props.onChange();
  };

  render() {

    const { data, classes, project, taxonomies, graph, defaultLang, projectUsers, user, assignedFilter, entitlements, taskStatusCounts, viewLang } = this.props;
    const { id, inScheme, status, assignedUser, assignedNote } = data;
    const { showAssignUserDialog } = this.state;
    const foundUser = projectUsers.find(pu => pu.value === assignedUser);
    const assigned = foundUser ?
      foundUser.label
      :
      "User not available";

    const isDeleted = data.pendingDeletion;
    const isDeprecated = data.deprecated;
    const isInWorkflowScheme = !data.inScheme || data.inScheme.length === 0 ?
      false
      :
      taxonomies.some(t => data.inScheme.includes(t.id));
    const disabled = isDeleted || isDeprecated || !isInWorkflowScheme;

    const usedStatus = status ?
      Array.isArray(status) ?
        status[0]
        :
        status
      :
      null;
    const statusText = usedStatus ?
      usedStatus === DRAFT ?
        "Draft"
        :
        usedStatus === APPROVED ?
          "Approved"
          :
          "Rejected"
      :
      "Uncategorised";

    const canEdit = usedStatus !== APPROVED && usedStatus !== REJECTED && isInWorkflowScheme;

    let taskBar;
    if (data.hasTask && data.hasTask.length > 0) {
      const tl = data.hasTask.length;
      const pendingWidth = taskStatusCounts.pending / tl * BAR_WIDTH;
      const approvedWidth = taskStatusCounts.approved / tl * BAR_WIDTH;
      const rejectedWidth = taskStatusCounts.rejected / tl * BAR_WIDTH;
      taskBar = <div style={{ width: BAR_WIDTH, height: 34, lineHeight: '32px', marginTop: 2, color: 'white' }}>
        {taskStatusCounts.pending > 0 &&
          <span
            data-test="pending-count"
            style={{
              display: 'inline-block',
              width: 'calc(' + pendingWidth + '% - 3px)',
              borderRight: 'solid 3px white',
              backgroundColor: '#ff6600',
              height: '100%',
              borderTopLeftRadius: BAR_RADIUS,
              borderBottomLeftRadius: BAR_RADIUS,
              ...(taskStatusCounts.approved === 0 && taskStatusCounts.rejected === 0) && {
                borderTopRightRadius: BAR_RADIUS,
                borderBottomRightRadius: BAR_RADIUS
              }
            }}>{taskStatusCounts.pending}</span>
        }
        {taskStatusCounts.approved > 0 &&
          <span
            data-test="approved-count"
            style={{
              display: 'inline-block',
              width: 'calc(' + approvedWidth + '% - 3px)',
              borderRight: 'solid 3px white',
              backgroundColor: '#97d700',
              height: '100%',
              ...(taskStatusCounts.pending === 0) && {
                borderTopLeftRadius: BAR_RADIUS,
                borderBottomLeftRadius: BAR_RADIUS
              },
              ...(taskStatusCounts.rejected === 0) && {
                borderTopRightRadius: BAR_RADIUS,
                borderBottomRightRadius: BAR_RADIUS
              }
            }}>{taskStatusCounts.approved}</span>
        }
        {taskStatusCounts.rejected > 0 &&
          <span
            data-test="rejected-count"
            style={{
              display: 'inline-block',
              width: 'calc(' + rejectedWidth + '% - 3px)',
              borderRight: 'solid 3px white',
              backgroundColor: '#DD2C00',
              height: '100%',
              ...(taskStatusCounts.pending === 0 && taskStatusCounts.approved === 0) && {
                borderTopLeftRadius: BAR_RADIUS,
                borderBottomLeftRadius: BAR_RADIUS
              },
              borderTopRightRadius: BAR_RADIUS,
              borderBottomRightRadius: BAR_RADIUS
            }}>{taskStatusCounts.rejected}</span>
        }
      </div>;
    }

    let notes;
    if (assignedNote) {
      notes = Object.keys(assignedNote).sort().map((lang) => {
        const noteItems = Array.isArray(assignedNote[lang]) ? [...assignedNote[lang]] : [assignedNote[lang]];
        let positions = {};
        noteItems.forEach((note, i) => positions[note] = i);
        return <div key={lang}>
          {noteItems
            .sort((a, b) => {
              if (a.toLowerCase() < b.toLowerCase()) return -1;
              if (a.toLowerCase() > b.toLowerCase()) return 1;
              return 0;
            })
            .map((note, noteIndex) =>
              <LangConfirmationField
                dataTest={"note-" + lang + "-" + noteIndex}
                focus={false}
                key={lang + "-" + noteIndex}
                canBeDeleted={false}
                multiline={true}
                text={note}
                lang={lang}
                isReadOnly={true} />
            )}
        </div>;
      });
    }

    const schemes = Array.isArray(inScheme) ? inScheme : [inScheme];

    return (
      <TableRow
        data-test={"resource-" + data.id}
        classes={{
          root: classes.stripedRow
        }}>
        <TableCell data-test="resource" component="td" className={classes.tableCell} style={{ maxWidth: 200 }}>
          <div style={{ paddingTop: 4 }}>
            <IriDisplay
              id={id}
              compact={true}
              components={taxonomies}
              projectIRI={project}
              handleNotAvailable={true}
              graph={graph}
              viewLang={viewLang}
              defaultLang={defaultLang} />
          </div>
        </TableCell>
        <TableCell data-test="component" component="td" className={classes.tableCell}>
          <div style={{ paddingTop: 4 }}>
            {schemes.map(scheme =>
              <IriDisplay
                useIfWorkflow={true}
                key={scheme}
                id={scheme}
                compact={true}
                components={taxonomies}
                projectIRI={project}
                handleNotAvailable={true}
                graph={graph}
                viewLang={viewLang}
                defaultLang={defaultLang} />
            )}
          </div>
        </TableCell>
        <TableCell component="td" className={classes.tableCell}>
          <div style={{ paddingTop: 4 }}>
            <Chip
              data-test="status"
              color="primary"
              avatar={
                <Avatar style={{ backgroundColor: 'inherit' }}>
                  {(!status || status === undefined) &&
                    <HelpIcon fontSize="small" />
                  }
                  {usedStatus === DRAFT &&
                    <NewReleasesIcon fontSize="small" />
                  }
                  {usedStatus === APPROVED &&
                    <MoodIcon fontSize="small" />
                  }
                  {usedStatus === REJECTED &&
                    <MoodBadIcon data-test="rejected-icon" fontSize="small" />
                  }
                </Avatar>
              }
              clickable={false}
              label={statusText}
              className={classes.statusChip}
            />
          </div>
        </TableCell>
        <TableCell component="td" className={classes.tableCell} align='left'>
          <div style={{ paddingTop: 4 }}>
            {assignedUser &&
              <Chip
                data-test="assignee"
                color="secondary"
                avatar={
                  <Avatar style={{ backgroundColor: 'inherit' }}>
                    <AssignmentIndIcon fontSize="small" />
                  </Avatar>
                }
                clickable={false}
                label={assigned}
                className={classes.statusChip}
              />
            }
          </div>
        </TableCell>
        <TableCell component="td" className={classes.tableCell}>
          {notes}
        </TableCell>
        <TableCell component="td" className={classes.tableCell} align="center" style={{ whiteSpace: 'nowrap' }}>
          {data.hasTask && data.hasTask.length > 0 && taskBar}
        </TableCell>
        <TableCell component="td" className={classes.tableCell} align='center'>
          <div style={{ paddingTop: 4 }}>
            {(entitlements.includes(ENTITLEMENTS.MANAGE_WORKFLOW) || entitlements.includes(ENTITLEMENTS.WORKFLOW_REVIEW))
              && !status && !disabled &&
              <Tooltip placement="right" title='Set to Draft'>
                <IconButton data-test="set-to-draft" size="small" onClick={() => this.setToStatus(DRAFT)}>
                  <NewReleasesIcon />
                </IconButton>
              </Tooltip>
            }
            {entitlements.includes(ENTITLEMENTS.MANAGE_WORKFLOW) && !disabled && status &&
              (!data.hasTask || taskStatusCounts.pending === 0) &&
              status[0] === DRAFT && assignedUser === user &&
              <Tooltip placement="right" title='Approve'>
                <IconButton data-test="approve-resource" size="small" onClick={this.setToApproved}>
                  <ThumbUpIcon />
                </IconButton>
              </Tooltip>
            }
          </div>
        </TableCell>
        <TableCell component="td" className={classes.tableCell} align='right'>
          <div style={{ paddingTop: 4, marginRight: 12 }}>
            {canEdit && entitlements.includes(ENTITLEMENTS.ASSIGN_WORKFLOW) && !disabled && status && status[0] === DRAFT
              && (assignedFilter === "UNASSIGNED" || assignedUser === user || !foundUser) &&
              <Tooltip placement="right" title='Assign'>
                <IconButton data-test="assign" size="small" onClick={this.showAssignUser}>
                  <PersonIcon />
                </IconButton>
              </Tooltip>
            }
            {canEdit && !disabled && showAssignUserDialog &&
              <AssignUserDialog
                onAssignUser={this.assignUser}
                existingNotes={assignedNote}
                defaultLang={defaultLang}
                exclude={assignedUser || "All"}
                projectUsers={projectUsers}
                onCancel={this.cancelAssignUser}
              />
            }
          </div>
        </TableCell>
      </TableRow >
    );
  }
}

ResourceDisplay.defaultProps = {
  taskStatusCounts: {}
};

ResourceDisplay.propTypes = {
  classes: PropTypes.object,
  taxonomies: PropTypes.array.isRequired,
  data: PropTypes.object.isRequired,
  graph: PropTypes.string.isRequired,
  taskStatusCounts: PropTypes.object,
  project: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  entitlements: PropTypes.array,
  user: PropTypes.string.isRequired,
  assignedFilter: PropTypes.string,
  viewLang: PropTypes.string,
  projectUsers: PropTypes.array.isRequired,
  defaultLang: PropTypes.string.isRequired
};

export default withStyles(styles)(withGS(ResourceDisplay, ["ALL"], null, {}, true));